const productPurchaseOrderTodoType = {
  // Fetch purchase order todos
  FETCH_PURCHASE_ORDER_TODOS_LIST: 'FETCH_PURCHASE_ORDER_TODOS_LIST',

  // Update purchase order todo actual fields
  UPDATE_PURCHASE_ORDER_TODO_ACTUAL_FIELDS: 'UPDATE_PURCHASE_ORDER_TODO_ACTUAL_FIELDS',

  // Delete purchase order todo
  DELETE_PURCHASE_ORDER_TODO: 'DELETE_PURCHASE_ORDER_TODO',

  // Bulk delete purchase order todos
  BULK_DELETE_PURCHASE_ORDER_TODOS: 'BULK_DELETE_PURCHASE_ORDER_TODOS',

  // Set filter values
  SET_FILTER_VALUES: 'SET_FILTER_VALUES',

  // Clear reducer
  CLEAR_REDUCER: 'CLEAR_REDUCER',
};

export default productPurchaseOrderTodoType;
